import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { commonStore } from 'stores';
import { useUserRole } from 'hooks';

import { Links } from 'links';

export const useNoAccess = () => {
  const navigate = useNavigate();
  const user = commonStore((state) => state.user);

  const { isAdmin } = useUserRole();

  useEffect(() => {
    if (!isAdmin && user) {
      navigate(Links.NoAccess);
    }
  }, [isAdmin, user]);
};
